import { useNavigate } from "react-router";

import { DropdownAction } from "@/components/organisms/DropdownAction";
import { ListChecksIcon } from "@/components/atoms/icons";
import { PathNamekAppsRoutes, PathNamekRoutes } from "@/router";
import type { GreenCenterMaterials } from "@/service/namek/useGetMaterialsByCVId";

type AssignMaterialActionsProps = {
  assignMaterials: GreenCenterMaterials;
};

export function AssignMaterialActions({ assignMaterials }: AssignMaterialActionsProps) {
  const navigate = useNavigate();
  const onClick = () => {
    navigate(
      `/${PathNamekAppsRoutes.CONFIG}/${PathNamekRoutes.CONFIG.ASSIGN_MATERIALS}/${assignMaterials.id}`,
    );
  };

  return (
    <>
      <DropdownAction>
        <DropdownAction.Item
          icon={<ListChecksIcon />}
          label="Materiales asignados"
          onClick={onClick}
        />
      </DropdownAction>
    </>
  );
}
